import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "compare-datasets",
  "name": "Compare Datasets",
  "category": "data",
  "description": "Compare two datasets and find differences",
  "icon": "GitCompare",
  "color": "cyan",
  "version": "1.0.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "Compare Datasets",
    "color": "#06b6d4"
  },
  "inputs": [
    {
      "name": "input1",
      "type": "main",
      "displayName": "Input 1",
      "required": true
    },
    {
      "name": "input2",
      "type": "main",
      "displayName": "Input 2",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "compare",
    "diff",
    "difference",
    "dataset"
  ]
};

export default definition;
